import React from 'react';
import { Card, CardBody } from 'reactstrap';

const Pricing = () => {
  const courses = [
    { srNo: 1, name: 'HS-CIT [Certificate in Information Technology]', duration: '132 Hours', actualFees: '4500/-' },
    { srNo: 2, name: 'HS-CIT (A) [Haryana State Certificate in IT Applications]', duration: '6 Months', actualFees: '9000/-' },
    { srNo: 3, name: 'HS-CIT (A+) [Haryana State Certificate in IT Advanced Applications]', duration: '1 Year', actualFees: '18000/-' },
    { srNo: 4, name: 'Certificate in Financial Accounting', duration: '120 Hours', actualFees: '4500/-' },
    { srNo: 5, name: 'Certificate in Advanced Accounting', duration: '120 Hours', actualFees: '4500/-' },
    { srNo: 6, name: 'Certificate in Advanced Excel', duration: '120 Hours', actualFees: '4500/-' },
    { srNo: 7, name: 'Certificate in AutoCAD', duration: '120 Hours', actualFees: '4500/-' },
    { srNo: 8, name: 'Certificate in IT Network Support', duration: '120 Hours', actualFees: '4500/-' },
    { srNo: 9, name: 'Certificate in IT Security Support', duration: '120 Hours', actualFees: '4500/-' },
    { srNo: 10, name: 'Certificate in Office Assistance', duration: '120 Hours', actualFees: '4500/-' },
    { srNo: 11, name: 'Certificate in Photo Editing', duration: '120 Hours', actualFees: '4500/-' },
    { srNo: 12, name: 'Certificate in Coral Draw (DTP)', duration: '120 Hours', actualFees: '4500/-' },
    { srNo: 13, name: 'Certificate in Adobe (DTP)', duration: '120 Hours', actualFees: '4500/-' },
    { srNo: 14, name: 'Certificate in Graphic Designing', duration: '120 Hours', actualFees: '4500/-' },
    { srNo: 15, name: 'Certificate in Video Editing', duration: '120 Hours', actualFees: '4500/-' },
    { srNo: 16, name: 'Certificate in English Communication & Soft Skills', duration: '120 Hours', actualFees: '4500/-' },
    { srNo: 17, name: 'Certificate in Data Entry and Data Management', duration: '120 Hours', actualFees: '4500/-' },
    { srNo: 18, name: 'Certificate in Digital Freelancing', duration: '60 Hours', actualFees: '2250/-' },
    { srNo: 19, name: 'Certificate in BFSI', duration: '120 Hours', actualFees: '4500/-' },
    { srNo: 20, name: 'Certificate in Retail Management', duration: '120 Hours', actualFees: '4500/-' },
    { srNo: 21, name: 'Certificate in Java', duration: '120 Hours', actualFees: '4500/-' },
    { srNo: 22, name: 'Certificate in Python', duration: '120 Hours', actualFees: '4500/-' },
    { srNo: 23, name: 'Certificate in C & C++ Programming', duration: '120 Hours', actualFees: '4500/-' },
    { srNo: 24, name: 'Certificate in PHP', duration: '120 Hours', actualFees: '4500/-' },
    { srNo: 25, name: 'Certificate in Web Designing', duration: '120 Hours', actualFees: '4500/-' },
    { srNo: 26, name: 'Certificate in Advanced Tally (with latest version of Tally Prime)', duration: '120 Hours', actualFees: '4500/-' },
    { srNo: 27, name: 'Certificate in Database Management System (DBMS)', duration: '120 Hours', actualFees: '4500/-' },
    { srNo: 28, name: 'Certificate in Data Structures using C and C++', duration: '120 Hours', actualFees: '4500/-' },
    { srNo: 29, name: 'Certificate in Social Media Marketing', duration: '60 Hours', actualFees: '2250/-' },
    { srNo: 30, name: 'Certificate in HTML with CSS', duration: '120 Hours', actualFees: '4500/-' },
    { srNo: 31, name: 'Certificate in C#', duration: '120 Hours', actualFees: '4500/-' },
  ];

  return (
    <div className='container-fluid mt-3 mb-3'>
      <div style={{ textAlign: 'justify' }}>
        <Card>
          <h3 className='text-center' style={{ color: '#123fae', backgroundColor: '#a2a2a208', fontWeight: "600" }}>
            <span style={{ color: "#d12023" }}> Fee Structure for</span> Skill Development Courses
          </h3>
          <CardBody>
            <div className="table-responsive">
              <table className="table table-bordered mt-3">
                <thead>
                  <tr>
                    <th className='text-center'>Sr. No.</th>
                    <th>Course Name</th>
                    <th>Duration </th>
                    <th>Total Fees</th>
                  </tr>
                </thead>
                <tbody>
                  {courses.map((course) => (
                    <tr key={course.srNo}>
                      <td className='text-center fw-bold'>{course.srNo}</td>
                      <td>{course.name}</td>
                      <td >{course.duration}</td>
                      <td >{course.actualFees}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default Pricing;

